import React, { useMemo, useState } from "react";
import { Competitions } from "../../../pages";
import { CompetitionController } from "../../../controllers";

const CompetitionsContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [createCompetitionModal, setCreateCompetitionModal] = useState(false);
  const [editCompetitionModal, setEditCompetitionModal] = useState(false);

  const competitionsTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    CompetitionController.useGetCompetitions(
      competitionsTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreateCompetition = () => {
    setCreateCompetitionModal(true);
  };
  const goToEditCompetition = () => {
    setEditCompetitionModal(true);
  };

  const closeModal = () => {
    setCreateCompetitionModal(false);
    setEditCompetitionModal(false);
  };
  return (
    <Competitions
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      closeModal={closeModal}
      goToCreateCompetition={goToCreateCompetition}
      goToEditCompetition={goToEditCompetition}
      createCompetitionModal={createCompetitionModal}
      editCompetitionModal={editCompetitionModal}
    />
  );
};

export default CompetitionsContainer;
